import { render, staticRenderFns } from "./DocPreviewDialog.vue?vue&type=template&id=6bb286be&scoped=true&"
import script from "./DocPreviewDialog.vue?vue&type=script&lang=ts&"
export * from "./DocPreviewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DocPreviewDialog.vue?vue&type=style&index=0&id=6bb286be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb286be",
  null
  
)

export default component.exports